export default __webpack_public_path__ + "static/media/bluePlusCircle.55e3c846.svg";